export default (url: string): boolean => url.match(/^https?:\/\//) !== null
